import React from "react";
import moment from "moment";
import "bootstrap-icons/font/bootstrap-icons.css";
import FundOption from "../../component/FundOption";
import HistoricalDownloadMenu from "../../component/HistoricalDownloadMenu";
import HistoricalUnitPricesTable from "../../component/HistoricalUnitPricesTable";
import UPPDatePicker from "../../component/UPPDatePicker";
import { formatDate } from "../../common/UppHelper";

class HistoricalUnitPricesPage extends React.Component {
  constructor(props) {
    super(props);

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    this.state = {
      FindByReportTypeData: [],
      fundOptionJson: [],
      startlocalDate: formatDate(yesterday, 3),
      endlocalDate: formatDate(new Date(), 3),
      selectedFundOption: "",
      tableSHow: false,
      errorMessageShow: false,
      tableErrorMsgShow: false,
      refreshPagination: false,
      datePickerPreviewDate: null,
    };
  }

  componentDidMount() {
    document.title = this.props.pageTitle;
    this.loadFunds();
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextState.selectedFundOption !== this.state.selectedFundOption ||
      nextState.startlocalDate !== this.state.startlocalDate ||
      nextState.endlocalDate !== this.state.endlocalDate ||
      nextState.tableSHow !== this.state.tableSHow ||
      nextState.errorMessageShow !== this.state.errorMessageShow ||
      nextState.tableErrorMsgShow !== this.state.tableErrorMsgShow ||
      nextState.refreshPagination !== this.state.refreshPagination ||
      nextState.datePickerPreviewDate !== this.state.datePickerPreviewDate ||
      nextState.FindByReportTypeData !== this.state.FindByReportTypeData ||
      nextState.fundOptionJson !== this.state.fundOptionJson
    );
  }

  loadFunds = async () => {
    try {
      const useLocal = process.env.REACT_APP_USE_LOCAL_DATA === "true";
      const fundsLocalFilePath = this.props.fundsLocalFilePath;

      let data;

      if (useLocal) {
        console.log("Using local funds JSON:", fundsLocalFilePath);

        const res = await fetch(fundsLocalFilePath);

        if (!res.ok) {
          throw new Error(`Failed to load local funds JSON: ${fundsLocalFilePath}`);
        }

        data = await res.json();
      } else {
        const params = new URLSearchParams({
          reportName: this.props.reportName,
        });

        const res = await fetch(`/api/historical-unit-prices/funds?${params.toString()}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
          mode: "same-origin",
          cache: "default",
        });

        if (!res.ok) {
          throw new Error("Failed to load funds API data");
        }

        data = await res.json();
      }

      this.setState({
        fundOptionJson: data.data || [],
      });
    } catch (error) {
      console.error("Error loading fund options:", error);

      this.setState({
        fundOptionJson: [],
      });
    }
  };

  handleSubmit = async (event) => {
    event.preventDefault();

    const {
      selectedFundOption,
      startlocalDate,
      endlocalDate,
      fundOptionJson,
    } = this.state;

    if (!selectedFundOption) {
      this.setState({
        errorMessageShow: true,
      });
      return;
    }

    if (this.state.errorMessageShow) {
      this.setState({
        errorMessageShow: false,
      });
    }

    const fromParameter = moment(startlocalDate, "DD/MM/YYYY", true);
    const toParameter = moment(endlocalDate, "DD/MM/YYYY", true);

    try {
      const useLocal = process.env.REACT_APP_USE_LOCAL_DATA === "true";
      const historicalLocalFilePath = this.props.historicalLocalFilePath;

      let data;

      if (useLocal) {
        console.log("Using local historical JSON:", historicalLocalFilePath);

        const res = await fetch(historicalLocalFilePath);

        if (!res.ok) {
          throw new Error(
            `Failed to load local historical JSON: ${historicalLocalFilePath}`
          );
        }

        data = await res.json();
      } else {
        const params = new URLSearchParams({
          reportName: this.props.reportName,
          fund: selectedFundOption,
          fromDate: fromParameter.format("DD-MM-YYYY"),
          toDate: toParameter.format("DD-MM-YYYY"),
        });

        const res = await fetch(`/api/historical-unit-prices?${params.toString()}`, {
          method: "GET",
          headers: {
            Accept: "application/json",
          },
          mode: "same-origin",
          cache: "default",
        });

        if (!res.ok) {
          const text = await res.text();
          console.error("Response body:", text);
          throw new Error(`HTTP error! status: ${res.status}`);
        }

        data = await res.json();
      }

      let resultData = data.data || [];

      if (Array.isArray(data)) {
        resultData = data;
      }

      if (useLocal && selectedFundOption) {
        const allFunds = fundOptionJson.flatMap(
          (group) => group.fundOptionsList || []
        );

        const selectedFund = allFunds.find(
          (fund) => fund.fundCode === selectedFundOption
        );

        const selectedFundName = selectedFund?.fundName || "";

        resultData = resultData.filter(
          (item) => item.fundName && item.fundName.includes(selectedFundName)
        );
      }

      if (data.status === "FAILURE" || !resultData || resultData.length === 0) {
        this.showTableError();
        return;
      }

      this.setState({
        tableSHow: true,
        FindByReportTypeData: resultData,
        tableErrorMsgShow: false,
        refreshPagination: true,
      });
    } catch (error) {
      console.error("Error loading historical prices:", error);
      this.showTableError();
    }
  };

  showTableError = () => {
    this.setState({
      tableSHow: true,
      FindByReportTypeData: [],
      tableErrorMsgShow: true,
      refreshPagination: false,
    });
  };

  cancelButton = () => {
    window.location.reload();
  };

  setSelectedFundOption = (item) => {
    this.setState({
      selectedFundOption: item,
    });
  };

  handleDateChange = (event) => {
    const { name, value } = event.target;

    this.setState({
      [name]: value,
    });
  };

  setRefreshPagination = (value) => {
    this.setState({
      refreshPagination: value,
    });
  };

  setDatePickerPreviewDate = (value) => {
    this.setState({
      datePickerPreviewDate: value,
    });
  };

  getFundOptions = () => {
    const { fundOptionJson } = this.state;

    return fundOptionJson.map((item) => ({
      label: item.heading,
      options: (item.fundOptionsList || []).map((fund) => ({
        label: fund.fundName,
        value: fund.fundCode,
      })),
    }));
  };

  renderFundError = () => {
    if (!this.state.errorMessageShow) {
      return null;
    }

    return (
      <div className="formItemStyle">
        <div className="alert alert-danger" role="alert" style={{ marginBottom: "0px" }}>
          <span aria-hidden="true" style={{ marginRight: "8px" }}>
            <i
              className="bi bi-exclamation-circle-fill"
              aria-hidden="true"
              style={{
                marginRight: "8px",
                color: "#a94442",
                fontSize: "18px",
                verticalAlign: "middle"
              }}
            />
          </span>

          <span className="visually-hidden">Error: </span>
          Please select one of the Funds
        </div>
      </div>
    );
  };

  renderTableError = () => {
    if (!this.state.tableErrorMsgShow) {
      return null;
    }

    return (
      <>
        <div className="alert alert-danger" role="alert" style={{ marginBottom: "0px" }}>
          <span aria-hidden="true" style={{ marginRight: "8px" }}>
            <i
              className="bi bi-exclamation-circle-fill"
              aria-hidden="true"
              style={{
                marginRight: "8px",
                color: "#a94442",
                fontSize: "18px",
                verticalAlign: "middle"
              }}
            />
          </span>
          <span className="visually-hidden">Error: </span>
          There is no data matching based on input. Please check your input and try it again.
        </div>
        <br />
      </>
    );
  };

  renderResults = () => {
    const {
      tableSHow,
      tableErrorMsgShow,
      FindByReportTypeData,
      refreshPagination,
      selectedFundOption,
      startlocalDate,
      endlocalDate,
    } = this.state;

    if (!tableSHow) {
      return null;
    }

    return (
      <div className="bootstrap3-layout">
        <div className="container">
          {this.renderTableError()}

          {!tableErrorMsgShow && (
            <form>
              <HistoricalDownloadMenu
                reportName={this.props.reportName}
                selectedFundOption={selectedFundOption}
                startDate={startlocalDate}
                endDate={endlocalDate}
                show={!tableErrorMsgShow && FindByReportTypeData.length > 0}
              />

              <HistoricalUnitPricesTable
                historicalData={FindByReportTypeData[0]}
                refreshPagination={refreshPagination}
                setRefreshPagination={this.setRefreshPagination}
              />
            </form>
          )}
        </div>
      </div>
    );
  };

  render() {
    const {
      selectedFundOption,
      startlocalDate,
      endlocalDate,
      datePickerPreviewDate,
    } = this.state;
    const fundOption = this.getFundOptions();

    return (
      <div style={{ width: "100%" }}>
        <div style={{ marginBottom: "30px" }}>
          <div className="bootstrap3-layout">
            <div className="container" style={{ padding: "21px" }}>
              <form onSubmit={this.handleSubmit}>
                <div className="row">
                  <div className="col-md-12 formItemStyle">
                    <h1 className="header1">Historical Unit Prices</h1>
                  </div>

                  <div className="col-md-6 col-sm-12 formItemStyle">
                    <label
                      className="formItemStyle"
                      id="aria-label"
                      htmlFor="aria-fund-input"
                    >
                      Fund
                    </label>

                    <FundOption
                      selectedFundValue={selectedFundOption}
                      itemOption={fundOption}
                      selectedFundOption={this.setSelectedFundOption}
                    />

                    {this.renderFundError()}
                  </div>

                  <div className="col-md-3 col-sm-12 formItemStyle date-picker-column">
                    <UPPDatePicker
                      inputLabel="From"
                      name="startlocalDate"
                      value={startlocalDate}
                      onChange={this.handleDateChange}
                      maxDate={endlocalDate}
                      rangeStart={startlocalDate}
                      rangeEnd={endlocalDate}
                      selectionMode="start"
                      previewDate={datePickerPreviewDate}
                      onPreviewDateChange={this.setDatePickerPreviewDate}
                    />
                  </div>

                  <div className="col-md-3 col-sm-12 formItemStyle date-picker-column">
                    <UPPDatePicker
                      inputLabel="To"
                      name="endlocalDate"
                      value={endlocalDate}
                      onChange={this.handleDateChange}
                      minDate={startlocalDate}
                      rangeStart={startlocalDate}
                      rangeEnd={endlocalDate}
                      selectionMode="end"
                      previewDate={datePickerPreviewDate}
                      onPreviewDateChange={this.setDatePickerPreviewDate}
                    />
                  </div>

                  <div
                    className="col-md-12 col-sm-12 formItemStyle"
                    style={{ marginBottom: "30px", marginTop: "10px" }}
                  >
                    <button
                      type="submit"
                      id="submit"
                      className="submit-button"
                      style={{ marginRight: "20px", width: "135px" }}
                    >
                      Show prices
                    </button>

                    <button
                      type="button"
                      className="download-button"
                      style={{ width: "135px" }}
                      onClick={this.cancelButton}
                    >
                      Reset
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <hr className="section-divider" />
        </div>

        {this.renderResults()}
      </div>
    );
  }
}

export default HistoricalUnitPricesPage;
